exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[lazy=loaded]{width:var(--width);height:var(--height)}img[lazy=loading]{width:38px!important;height:38px!important}", ""]);

// exports
